import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import strings from '../../Globalization';
import IncubatorResultModelForm from '../forms/IncubatorResultModelForm';
import { useSterilizerCycleInfo } from './Context';

const IncubatorResultDialog = () => {
    const { incubatorResultDialogTitle=strings.CIResult, data, combos, incubatorResultDialogOpen, incubatorResultActiveRecord, onCloseIncubatorResultDialog } = useSterilizerCycleInfo();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const handleOnSetActiveRecord = (record, opts = { refresh: true }) => {
		if (typeof onCloseIncubatorResultDialog === 'function') {
			onCloseIncubatorResultDialog();
		}
	};
	return (
		<Dialog
			open={incubatorResultDialogOpen}
			onClose={onCloseIncubatorResultDialog}
			sx={{ '& .MuiDialog-paper': { minWidth: '60vw' } }}
			fullScreen={fullScreen}
		>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{incubatorResultDialogTitle}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<IncubatorResultModelForm
					setActiveRecord={handleOnSetActiveRecord}
					activeRecord={
						incubatorResultActiveRecord ? { ...incubatorResultActiveRecord, data } : incubatorResultActiveRecord
					}
					containerProps={{ elevation: 0 }}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default IncubatorResultDialog;
